import { useMutation, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Sustituir la lista de CC del ticket (array de emails). Invalida el detalle,
// que trae ticket.cc y, por prefijo, el historial (el cambio queda registrado).
const useActualizarCc = (headquarter, id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (emails) => ticketsService.actualizarCc({ headquarter, id, emails }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.detalle(headquarter, id) }),
  });
};

export default useActualizarCc;
